import React, { Component } from 'react';
import './Map.scss';
import L from 'leaflet';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import * as MapActions from './actions/MapActions.js';

import 'leaflet-groupedlayercontrol';
import './SemiCircle.js';

const style = {
	width: '100%',
	height: '60vh',
	zIndex: 1
};

class Map extends Component {
	constructor() {
		super();

		this.mapContext = {
			id: null,
			_self: null,
			map: null,
			Layer2G: null,
			Layer3G: null,
			Layer4G: null,
			// added overlays
			overlays: [],

			// active layers
			activeLayers: [],

			// map layercontrol
			layerControl: null,
			topology: { '2G': [], '3G': [], '4G': [] },

			legend: { LegendElements: [], Title: '' },
			legendLeft: { LegendElements: [], Title: '' }
		};
	}

	componentDidMount() {
		this.initMap();
	}

	componentDidUpdate() {
		const { id, mapUpdated, maps, zoomToUpdate } = this.props;
		// check if data has changed
		if (this.mapContext.id === mapUpdated) {
			this.mapContext.activeLayers = this.getActiveOverlays();
			this.mapContext.activePopup = this.getActivePopup();
			this.mapContext.topology = maps.length !== 0 && !_.isUndefined(mapUpdated) ? maps.filter(item => item.id === mapUpdated)[0].topology : { '2G': [], '3G': [], '4G': [] };
			if (this.mapContext.map.getZoom() > zoomToUpdate) {
				// this.updateTopology(this.mapContext.topology);
			} else {
				this.RemoveLayerById('2G');
				this.RemoveLayerById('3G');
				this.RemoveLayerById('4G');
			}
			const legend = maps.length !== 0 && !_.isUndefined(mapUpdated) ? maps.filter(item => item.id === mapUpdated)[0].legend : { LegendElements: [], Title: '' };
			this.AddLegend(legend.legendElements, legend.title);
			const legendLeft = maps.length !== 0 && !_.isUndefined(mapUpdated) ? maps.filter(item => item.id === mapUpdated)[0].legendLeft : { LegendElements: [], Title: '' };
			this.AddLegendLeft(legendLeft.legendElements, legendLeft.title);
		}
	}

	initMap() {
		const { id, zoomToUpdate, onUpdateCoordinates, onAddMap, scale, lat, lon, zoom } = this.props;
		this.mapContext.id = id;
		this.mapContext._self = this;
		// added overlays
		this.mapContext.overlays = [];

		// active layers
		this.mapContext.activeLayers = [];

		// initialize the map on the "map" div with a given center and zoom
		const osmBase = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}');
		const osmSatellite = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}');

		const baseMaps = {
			Map: osmBase,
			Satellite: osmSatellite
		};

		this.mapContext.map = L.map(id, {
			center: [lat, lon],
			zoom,
			attributionControl: false,
			preferCanvas: true
		});

		// now you can add the basemap
		osmBase.addTo(this.mapContext.map);

		this.mapContext.layerControl = L.control.groupedLayers(baseMaps).addTo(this.mapContext.map);

		if (scale) {
			L.control.scale().addTo(this.mapContext.map);
		}

		const that = this;
		this.mapContext.map.on('moveend', (e) => {
			const coordinates = that.GetMapDataBounds();
			const value = { id, newCoordinates: coordinates };
			if (this.mapContext.map.getZoom() > zoomToUpdate) {
				onUpdateCoordinates(value);
			}
			// if (that.props.driveTestData !== undefined) {
			// 	that.props.driveTestData(that);
			// }
		});

		// Fix map drift for Leaflet.sync
		this.mapContext.map.on('dragend', (e) => {
			// console.log('Moved!');
			// console.log(this.mapContext.map._container.id);
			const currentZoom = this.mapContext.map.getZoom();
			setTimeout(() => {
				this.mapContext.map.setZoom(currentZoom);
			}, 1);
		});

		onAddMap({ id, coordinates: this.GetMapDataBounds(), instance: this.mapContext.map, control: this });

		setTimeout(() => { this.mapContext.map.invalidateSize(); }, 500);
	}

	addTopologyLabels(topology, layerName) {
		this.RemoveLayerById(layerName);
		this.Markers = [];
		topology.forEach(item => {
			// Offset
			const lat = item.latitude + 0.0001;
			const lon = item.longitude + 0.002;
			const coords = L.latLng(lat, lon);
			// const markerLable = L.marker(coords).addTo(this.mapContext.map);
			const textMarker = L.marker(coords, {
				icon: L.divIcon({
					// html: `<label style="font-weight: bold; border: 1px solid">${item.siteId}</label>`,
					html: `<label style="font-weight: bold;
										text-shadow:
										1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white;
										2px 2px 0 white, -2px 2px 0 white, 2px -2px 0 white, -2px -2px 0 white;
										3px 3px 0 white, -3px 3px 0 white, 3px -3px 0 white, -3px -3px 0 white;
					">${item.label}</label>`,
					className: 'text-below-marker',
				})
			});
			this.Markers.push(textMarker);
		});

		const layer = L.layerGroup(this.Markers, { id: layerName });
		layer.addTo(this.mapContext.map);
	}

	updateTopology2g(topology, layerName) {
		this.RemoveLayerById(layerName);
		this.Markers2G = [];

		const currentZoom = this.mapContext.map.getZoom();
		const radius = this.GetRadius(currentZoom);

		topology.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;
			// const code = item.code === undefined ? '' : item.code.split(' ')[0];

			// let cellColor = '#B80000';
			// if (_.isUndefined(item.code)) {
			// 	color = '#B80000';
			// } else if (item.code % 2 === 0) {
			// 	color = this.intToRGB(item.code * 10000);
			// } else {
			// 	color = this.invertColor(this.intToRGB(item.code * 10000));
			// }

			let cellColor = '#B80000';
			let cellRadius = 300;
			switch (item.band) {
							case 900:
								cellColor = '#49bbf1';
								cellRadius = 300;
								break;
							case 1800:
								cellColor = '#92d6f7';
								cellRadius = 275;
								break;
							default:
								cellColor = '#00000';
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				// radius: 100 + radius,
				// radius: 200,
				radius: cellRadius,
				startAngle: start,
				stopAngle: end,
				color: '#0e86be',
				weight: 2,
				opacity: 1,
				fillColor: cellColor,
				fillOpacity: 0.75
			});
			this.Markers2G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopologySeparated(item)}<br>`, { autoPan: false }));
		});

		const layer = L.layerGroup(this.Markers2G, { id: layerName });
		layer.addTo(this.mapContext.map);
	}

	updateTopology3g(topology, layerName) {
		this.RemoveLayerById(layerName);
		this.Markers3G = [];

		const currentZoom = this.mapContext.map.getZoom();
		const radius = this.GetRadius(currentZoom);

		// 3G
		topology.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;

			// let color = '#008000';
			// if (_.isUndefined(item.code)) {
			// 	color = '#008000';
			// } else if (item.code % 2 === 0) {
			// 	color = this.intToRGB(item.code * 10000);
			// } else {
			// 	color = this.invertColor(this.intToRGB(item.code * 10000));
			// }

			let cellColor = '#008000';
			let cellRadius = 250;
			switch (item.band) {
							case 900:
								cellColor = '#fdb233';
								cellRadius = 250;
								break;
							case 2100:
								cellColor = '#ffd085';
								cellRadius = 225;
								break;
							default:
								cellColor = '#00000';
								cellRadius = 200;
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				// radius: 80 + radius,
				// radius: 150,
				radius: cellRadius,
				startAngle: start,
				stopAngle: end,
				color: '#fca103',
				weight: 2,
				opacity: 1,
				fillColor: cellColor,
				fillOpacity: 0.75
			});
			this.Markers3G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopologySeparated(item)}<br>`, { autoPan: false }));
		});

		const layer = L.layerGroup(this.Markers3G, { id: layerName });
		layer.addTo(this.mapContext.map);
	}

	updateTopology4g(topology, layerName) {
		this.RemoveLayerById(layerName);
		this.Markers4G = [];

		const currentZoom = this.mapContext.map.getZoom();
		const radius = this.GetRadius(currentZoom);

		// 4G
		topology.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;

			// let color = '#0033CC';
			// if (_.isUndefined(item.code)) {
			// 	color = '#0033CC';
			// } else if (item.code % 2 === 0) {
			// 	color = this.intToRGB(item.code * 10000);
			// } else {
			// 	color = this.invertColor(this.intToRGB(item.code * 10000));
			// }

			let cellColor = '#0033CC';
			let cellRadius = 175;
			switch (item.band) {
							case 800:
								cellColor = '#eb2427';
								cellRadius = 175;
								break;
							case 2100:
								cellColor = '#f37c7d';
								cellRadius = 150;
								break;
							case 2600:
								cellColor = '#fbd3d4';
								cellRadius = 125;
								break;
							default:
								cellColor = '#00000';
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				// radius: 70 + radius,
				// radius: 100,
				radius: cellRadius,
				startAngle: start,
				stopAngle: end,
				color: '#e91619',
				weight: 2,
				opacity: 1,
				fillColor: cellColor,
				fillOpacity: 0.75
			});
			this.Markers4G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopologySeparated(item)}<br>`, { autoPan: false }));
		});

		const layer = L.layerGroup(this.Markers4G, { id: layerName });
		layer.addTo(this.mapContext.map);
	}

	updateTopology5g(topology, layerName) {
		this.RemoveLayerById(layerName);
		this.Markers5G = [];

		const currentZoom = this.mapContext.map.getZoom();
		const radius = this.GetRadius(currentZoom);

		// 5G
		topology.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;

			// let color = '#0033CC';
			// if (_.isUndefined(item.code)) {
			// 	color = '#0033CC';
			// } else if (item.code % 2 === 0) {
			// 	color = this.intToRGB(item.code * 10000);
			// } else {
			// 	color = this.invertColor(this.intToRGB(item.code * 10000));
			// }

			let cellColor = '#0c9e35';
			let cellRadius = 175;
			switch (item.band) {
							case 78:
								cellColor = '#0c9e35';
								cellRadius = 100;
								break;
							default:
								cellColor = '#00000';
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				// radius: 70 + radius,
				// radius: 100,
				radius: cellRadius,
				startAngle: start,
				stopAngle: end,
				color: '#0c9e35',
				weight: 2,
				opacity: 1,
				fillColor: cellColor,
				fillOpacity: 0.75
			});
			this.Markers5G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopologySeparated(item)}<br>`, { autoPan: false }));
		});

		const layer = L.layerGroup(this.Markers5G, { id: layerName });
		layer.addTo(this.mapContext.map);
	}

	updateTopologyCarriersColors(topology, layerName) {
		this.RemoveLayerById(layerName);
		this.Markers4G = [];

		const currentZoom = this.mapContext.map.getZoom();
		const radius = this.GetRadius(currentZoom);

		topology.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;

			let cellRadius = 175;
			let borderColor = '#e91619';
			if (item.technology === '2G') {
				borderColor = '#0e86be';
				switch (item.band) {
								case 900:
									cellRadius = 300;
									break;
								case 1800:
									cellRadius = 275;
									break;
								default:
				}
			} else if (item.technology === '3G') {
				borderColor = '#fca103';
				switch (item.band) {
								case 900:
									cellRadius = 250;
									break;
								case 2100:
									cellRadius = 225;
									break;
								default:
									cellRadius = 200;
				}
			} else if (item.technology === '4G') {
				borderColor = '#e91619';
				switch (item.band) {
								case 800:
									cellRadius = 175;
									break;
								case 2100:
									cellRadius = 150;
									break;
								case 2600:
									cellRadius = 125;
									break;
								default:
				}
			} else if (item.technology === '5G') {
				borderColor = '#0c9e35';
				switch (item.band) {
								case 78:
									cellRadius = 100;
									break;
								default:
				}
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				// radius: 70 + radius,
				// radius: 100,
				radius: cellRadius,
				startAngle: start,
				stopAngle: end,
				color: borderColor,
				weight: 1,
				opacity: 1,
				fillColor: item.colorCode,
				fillOpacity: 0.75
			});
			this.Markers4G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopologySeparated(item)}<br>`, { autoPan: false }));
		});

		const layer = L.layerGroup(this.Markers4G, { id: layerName });
		layer.addTo(this.mapContext.map);
	}

	updateTopology(topology) {
		this.Markers2G = [];
		this.Markers3G = [];
		this.Markers4G = [];

		const currentZoom = this.mapContext.map.getZoom();
		const radius = this.GetRadius(currentZoom);

		this.RemoveLayer(this.mapContext.Layer2G);
		this.RemoveLayer(this.mapContext.Layer3G);
		this.RemoveLayer(this.mapContext.Layer4G);

		topology.twoG.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;
			const code = item.code === undefined ? '' : item.code.split(' ')[0];

			let color = '#B80000';
			if (_.isUndefined(item.code)) {
				color = '#B80000';
			} else if (item.code % 2 === 0) {
				color = this.intToRGB(item.code * 10000);
			} else {
				color = this.invertColor(this.intToRGB(item.code * 10000));
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				radius: 100 + radius,
				startAngle: start,
				stopAngle: end,
				color: '#B80000',
				weight: 2,
				opacity: 1,
				fillColor: color,
				fillOpacity: 0.3
			});
			this.Markers2G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopology(item)}<br>`, { autoPan: false }));
		});

		this.mapContext.Layer2G = L.layerGroup(this.Markers2G, { id: '2G' });

		// double check remove layers to avoid zoom bug
		// RemoveLayer(Layer2G);
		this.mapContext.overlays.push(this.mapContext.Layer2G);

		this.mapContext.layerControl.addOverlay(this.mapContext.Layer2G, '2G', 'Topology');

		this.mapContext.activeLayers.forEach(item => {
			switch (item) {
							case '2G':
								this.mapContext.Layer2G.addTo(this.mapContext.map);
								break;
							default:
								break;
			}
		});

		// 3G
		topology.threeG.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;

			let color = '#008000';
			if (_.isUndefined(item.code)) {
				color = '#008000';
			} else if (item.code % 2 === 0) {
				color = this.intToRGB(item.code * 10000);
			} else {
				color = this.invertColor(this.intToRGB(item.code * 10000));
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				radius: 91 - item.cell.substr(item.cell.length - 1) * 5 + radius,
				startAngle: start,
				stopAngle: end,
				color: '#008000',
				weight: 2,
				opacity: 1,
				fillColor: color,
				fillOpacity: 0.3
			});
			this.Markers3G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopology(item)}<br>`, { autoPan: false }));
		});

		this.mapContext.Layer3G = L.layerGroup(this.Markers3G, { id: '3G' });

		// double check remove layers to avoid zoom bug
		// RemoveLayer(Layer3G);
		this.mapContext.overlays.push(this.mapContext.Layer3G);

		this.mapContext.layerControl.addOverlay(this.mapContext.Layer3G, '3G', 'Topology');

		this.mapContext.activeLayers.forEach(item => {
			switch (item) {
							case '3G':
								this.mapContext.Layer3G.addTo(this.mapContext.map);
								break;
							default:
								break;
			}
		});

		// 4G
		topology.fourG.forEach(item => {
			const start = item.azimuth - item.beamWidth / 2;
			const end = item.azimuth + item.beamWidth / 2;

			let color = '#0033CC';
			if (_.isUndefined(item.code)) {
				color = '#0033CC';
			} else if (item.code % 2 === 0) {
				color = this.intToRGB(item.code * 10000);
			} else {
				color = this.invertColor(this.intToRGB(item.code * 10000));
			}

			const marker = L.semiCircle([item.latitude, item.longitude], {
				radius: 81 - item.cell.substr(item.cell.length - 1) + radius,
				startAngle: start,
				stopAngle: end,
				color: '#0033CC',
				weight: 2,
				opacity: 1,
				fillColor: color,
				fillOpacity: 0.3
			});
			this.Markers4G.push(marker.bindPopup(`<br>${this.makeDetailsTableTopology(item)}<br>`, { autoPan: false }));
		});

		this.mapContext.Layer4G = L.layerGroup(this.Markers4G, { id: '4G' });

		// double check remove layers to avoid zoom bug
		// RemoveLayer(Layer4G);
		this.mapContext.overlays.push(this.mapContext.Layer4G);

		this.mapContext.layerControl.addOverlay(this.mapContext.Layer4G, '4G', 'Topology');

		this.mapContext.activeLayers.forEach(item => {
			switch (item) {
							case '4G':
								this.mapContext.Layer4G.addTo(this.mapContext.map);
								break;
							default:
								break;
			}
		});
	}

	makeDetailsTableTopology(item) {
		const table = `<table class="table table-striped">

							<tr>
							<th>Latitude: </th>
							<td>${item.latitude}</td>
							</tr>

							<tr>
							<th>Longitude: </th>
							<td>${item.longitude}</td>
							</tr>

							<tr>
							<th>Cell Name: </th>
							<td>${item.cell}</td>
							</tr>

							<tr>
							<th>Technology: </th>
							<td>${item.tech}</td>
							</tr>

							<tr>
							<th>Azimuth: </th>
							<td>${item.azimuth}</td>
							</tr>

							<tr>
							<th>Code: </th>
							<td>${item.code}</td>
							</tr>

</table>`;

		return table;
	}

	makeDetailsTableTopologySeparated(item) {
		const table = `<table class="table table-striped">
		<tr>
		<th>Tech: </th>
		<td>${item.technology}</td>
		</tr>
		<tr>
		<th>SiteId: </th>
		<td>${item.siteId}</td>
		</tr>
		<tr>
		<th>Cell Name: </th>
		<td>${item.cellName}</td>
		</tr>
		<tr>
		<th>Band: </th>
		<td>${item.band}</td>
		</tr>
		<tr>
		<th>Code: </th>
		<td>${item.code}</td>
		</tr>
		<tr>
		<th>Latitude: </th>
		<td>${item.latitude}</td>
		</tr>
		<tr>
		<th>Longitude: </th>
		<td>${item.longitude}</td>
		</tr>
		<th>Azimuth: </th>
		<td>${item.azimuth}</td>
		</tr>
		<th>Height: </th>
		<td>${item.height}</td>
		</tr>
		<th>M. Tilt: </th>
		<td>${item.mechanicalTilt}</td>
		</tr>
		<th>E. Tilt: </th>
		<td>${item.electricalTilt}</td>
		</tr>
		</table>`;
		return table;
	}

	GetRadius(currentZoom) {
		let radius = 0;
		if (currentZoom === 7) {
			radius = 10000;
		} else if (currentZoom === 8) {
			radius = 5000;
		} else if (currentZoom === 9) {
			radius = 2000;
		} else if (currentZoom === 10) {
			radius = 1000;
		} else if (currentZoom === 11) {
			radius = 500;
		} else if (currentZoom === 12) {
			radius = 300;
		} else if (currentZoom === 13) {
			radius = 100;
		} else if (currentZoom === 14) {
			radius = 50;
		} else if (currentZoom === 15) {
			radius = 30;
		} else if (currentZoom === 16) {
			radius = 20;
		} else if (currentZoom === 17) {
			radius = 10;
		} else if (currentZoom === 18) {
			radius = 5;
		}
		return radius;
	}

	GetMapDataBounds() {
		const { map } = this.mapContext;
		return {
			TopRightCornerLatitude: map.getBounds().getNorth(),
			TopRightCornerLongitude: map.getBounds().getEast(),
			BottomLeftCornerLatitude: map.getBounds().getSouth(),
			BottomLeftCornerLongitude: map.getBounds().getWest(),
			CenterLatitude: map.getCenter().lat,
			CenterLongitude: map.getCenter().lng,
			zoom: map.getZoom(),
		};
	}

	RemoveLayer(layer) {
		const thatState = this.mapContext;
		if (layer !== undefined && layer !== null) {
			thatState.layerControl._layers.forEach((obj, index) => {
				if (obj.layer.options !== undefined) {
					if (obj.layer.options.id === layer.options.id) {
						thatState.layerControl._layers.splice(index, 1);
						thatState.layerControl._update();
					}
				}
			});
			thatState.map.eachLayer((obj) => {
				// Check if it's an overlay and added to the map
				if (obj.options.id === layer.options.id) {
					thatState.map.removeLayer(obj);
				}
			});
		}
	}

	RemoveLayerById(layerId) {
		const thatState = this.mapContext;
		if (layerId !== undefined && layerId !== null) {
			thatState.layerControl._layers.forEach((obj, index) => {
				if (obj.layer.options !== undefined) {
					if (obj.layer.options.id === layerId) {
						thatState.layerControl._layers.splice(index, 1);
						thatState.layerControl._update();
					}
				}
			});
			thatState.map.eachLayer((obj) => {
				// Check if it's an overlay and added to the map
				if (obj.options.id === layerId) {
					thatState.map.removeLayer(obj);
				}
			});
		}
	}

	getActiveOverlays() {
		const { map } = this.mapContext;
		// Create array for holding active layers
		const active = [];
		const thatState = this.mapContext;
		// Iterate all layers in control
		map.eachLayer((obj) => {
			// Check if it's an overlay and added to the map
			if (thatState.map.hasLayer(obj) && obj.options.pane === 'overlayPane') {
				// Push layer to active array
				active.push(obj.options.id);
			}
		});

		// Return array
		return active;
	}

	getActivePopup() {
		// Create array for holding active layers
		this.activePopup = undefined;
		const thatState = this.mapContext;
		if (this.activePopup === undefined) {
			// Iterate all layers in control
			thatState.map.eachLayer((obj) => {
				// Check if it's an overlay and added to the map
				if (obj.options.pane === 'markerPane') {
					// Verificação adicionada, dava erro a mover mapa
					if (obj.getPopup() !== undefined) {
						if (obj.getPopup().isOpen()) {
							// Push layer to active array
							this.activePopup = obj.options.title;
						}
					}
				}
			});
		}
		// Return array
		return this.activePopup;
	}

	AddLegend(legendElements, title) {
		const thatState = this.mapContext;
		if (thatState.legend instanceof L.Control) { thatState.map.removeControl(thatState.legend); }

		const legend = L.control({ id: 'legend', position: 'bottomright' });

		legend.onAdd = (map) => {
			const div = L.DomUtil.create('div', 'leaflet-info leaflet-legend');
			div.innerHTML += `<b>${title}:</b><br>`;
			// loop through our density intervals and generate a label with a colored square for each interval
			for (let i = 0; i < legendElements.length; i++) {
				div.innerHTML += `<i style="background:${legendElements[i].legendColor}"></i><span>${legendElements[i].legendValue}</span><br>`;
			}

			return div;
		};

		if (!_.isEmpty(legendElements)) {
			thatState.legend = legend;
			legend.addTo(thatState.map);
		}
	}

	AddLegendLeft(legendElements, title) {
		const thatState = this.mapContext;
		if (thatState.legendLeft instanceof L.Control) { thatState.map.removeControl(thatState.legendLeft); }

		const legendLeft = L.control({ id: 'legendLeft', position: 'bottomleft' });

		legendLeft.onAdd = (map) => {
			const div = L.DomUtil.create('div', 'leaflet-info leaflet-legend');
			div.innerHTML += `<b>${title}:</b><br>`;
			// loop through our density intervals and generate a label with a colored square for each interval
			for (let i = 0; i < legendElements.length; i++) {
				div.innerHTML += `<i style="background:${legendElements[i].legendColor}"></i><span>${legendElements[i].legendValue}</span><br>`;
			}

			return div;
		};

		if (!_.isEmpty(legendElements)) {
			thatState.legendLeft = legendLeft;
			legendLeft.addTo(thatState.map);
		}
	}

	intToRGB(i) {
		const c = (i && 0x00FFFFFF)
			.toString(16)
			.toUpperCase();

		return '#fff000'.substring(0, 7 - c.length) + c;
	}

	invertColor(hex) {
		let _hex = hex;
		if (_hex.indexOf('#') === 0) {
			_hex = hex.slice(1);
		}
		// convert 3-digit hex to 6-digits.
		if (_hex.length === 3) {
			_hex = _hex[0] + _hex[0] + _hex[1] + _hex[1] + _hex[2] + _hex[2];
		}
		if (_hex.length !== 6) {
			throw new Error('Invalid HEX color.');
		}
		// invert color components
		const r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16);
		const g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16);
		const b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
		// pad each with zeros and return
		return `#${this.padZero(r)}${this.padZero(g)}${this.padZero(b)}`;
	}

	padZero(str, len) {
		const _len = len || 2;
		const zeros = new Array(_len).join('0');
		return (zeros + str).slice(-_len);
	}

	render() {
		const { id, height } = this.props;
		return <div id={id} style={{ ...style, height: height || style.height }} />;
	}
}

Map.propTypes = {
	id: PropTypes.string.isRequired,
	scale: PropTypes.bool.isRequired,
	mapUpdated: PropTypes.string,
	maps: PropTypes.array,
	zoomToUpdate: PropTypes.number,
	onUpdateCoordinates: PropTypes.func,
	onAddMap: PropTypes.func,
	lat: PropTypes.number,
	lon: PropTypes.number,
	zoom: PropTypes.number,
	height: PropTypes.string
};

const mapStateToProps = state => ({
	lat: state.mapReducer.lat,
	lon: state.mapReducer.lon,
	zoom: state.mapReducer.zoom,
	mapUpdated: state.mapReducer.mapUpdated,
	maps: state.mapReducer.maps,
	zoomToUpdate: state.mapReducer.zoomToUpdate
	// topologyData: { "2G": [], "3G": [], "4G": [] }
});

const mapDispatchToProps = dispatch => bindActionCreators(MapActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Map);
// export default Map;
